<template>
  <div v-if="showDebugger" class="logout-debugger">
    <div class="logout-debugger__header">
      <h3>🔍 Logout Debug Monitor</h3>
      <v-btn @click="showDebugger = false" icon small>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    
    <div class="logout-debugger__content">
      <div class="debug-section">
        <h4>📊 Cleanup Status</h4>
        <div class="cleanup-status">
          <div class="status-item">
            <span class="status-label">localStorage:</span>
            <span :class="['status-value', cleanupStatus.localStorage ? 'success' : 'error']">
              {{ cleanupStatus.localStorage ? '✅ Cleared' : '❌ Not Cleared' }}
            </span>
          </div>
          <div class="status-item">
            <span class="status-label">sessionStorage:</span>
            <span :class="['status-value', cleanupStatus.sessionStorage ? 'success' : 'error']">
              {{ cleanupStatus.sessionStorage ? '✅ Cleared' : '❌ Not Cleared' }}
            </span>
          </div>
          <div class="status-item">
            <span class="status-label">Cookies:</span>
            <span :class="['status-value', cleanupStatus.cookies ? 'success' : 'error']">
              {{ cleanupStatus.cookies ? '✅ Cleared' : '❌ Not Cleared' }}
            </span>
          </div>
          <div class="status-item">
            <span class="status-label">Store:</span>
            <span :class="['status-value', cleanupStatus.storeModules ? 'success' : 'error']">
              {{ cleanupStatus.storeModules ? '✅ Cleared' : '❌ Not Cleared' }}
            </span>
          </div>
        </div>
      </div>
      
      <div class="debug-actions">
        <v-btn @click="checkCleanupStatus" small outlined>Check Status</v-btn>
        <v-btn @click="showDebugger = false" small>Close</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoutDebugger',
  data() {
    return {
      showDebugger: false,
      cleanupStatus: {
        localStorage: false,
        sessionStorage: false,
        cookies: false,
        storeModules: false
      }
    }
  },
  mounted() {
    // Show debugger when logout starts
    this.$root.$on('logout-debug-start', () => {
      this.showDebugger = true
      this.checkCleanupStatus()
    })
    
    // Update cleanup status when verification completes
    this.$root.$on('logout-verification-complete', (results) => {
      this.cleanupStatus = { ...results }
    })
  },
  methods: {
    checkCleanupStatus() {
      // Manually check cleanup status
      this.cleanupStatus = {
        localStorage: this.checkLocalStorage(),
        sessionStorage: this.checkSessionStorage(),
        cookies: this.checkCookies(),
        storeModules: this.checkStoreModules()
      }
    },
    
    checkLocalStorage() {
      const keysToCheck = ['formId', 'userId', 'countryCode', 'aws-amplify-federatedInfo']
      return keysToCheck.every(key => localStorage.getItem(key) === null)
    },
    
    checkSessionStorage() {
      return sessionStorage.length === 0
    },
    
    checkCookies() {
      return document.cookie.split(';').filter(cookie => cookie.trim().length > 0).length === 0
    },
    
    checkStoreModules() {
      try {
        const userState = this.$store.getters['user/getCurrentCognitoUser']
        const cachedCredentials = this.$store.getters['user/getCachedAuthCredentials']
        return userState === undefined && cachedCredentials === undefined
      } catch {
        return false
      }
    }
  }
}
</script>

<style scoped>
.logout-debugger {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 350px;
  max-height: 60vh;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  overflow: hidden;
}

.logout-debugger__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.logout-debugger__header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.logout-debugger__content {
  padding: 16px;
  max-height: 50vh;
  overflow-y: auto;
}

.debug-section {
  margin-bottom: 20px;
}

.debug-section h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #666;
}

.cleanup-status {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #f9f9f9;
}

.status-label {
  font-weight: bold;
  color: #333;
}

.status-value.success {
  color: #4caf50;
}

.status-value.error {
  color: #f44336;
}

.debug-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
}
</style> 